// src/api/events.js
import { 
  collection, 
  query, 
  where, 
  getDocs, 
  doc, 
  getDoc,
  orderBy,
  limit 
} from 'firebase/firestore';
import { db } from '../firebase';

// Récupérer tous les événements d'une société spécifique
export const fetchEventsByCompany = async (companyId, limitCount = 10) => {
  try {
    console.log('🔍 API: Recherche événements pour companyId:', companyId);
    
    // D'abord essayer une requête simple sans orderBy pour tester
    const eventsQuery = query(
      collection(db, 'events'),
      where('companyId', '==', companyId),
      limit(limitCount)
    );
    
    console.log('📤 API: Exécution de la requête...');
    const querySnapshot = await getDocs(eventsQuery);
    
    console.log('📥 API: QuerySnapshot reçu, docs:', querySnapshot.docs.length);
    
    const events = querySnapshot.docs.map(doc => {
      const data = doc.data();
      console.log('📄 API: Document trouvé:', doc.id, data);
      return {
        id: doc.id,
        ...data
      };
    });
    
    console.log('✅ API: Events finaux:', events);
    return events;
  } catch (error) {
    console.error('❌ API: Erreur complète:', error);
    console.error('❌ API: Error message:', error.message);
    console.error('❌ API: Error code:', error.code);
    return [];
  }
};

// Récupérer un événement spécifique par ID
export const fetchEventById = async (eventId) => {
  try {
    const eventDoc = await getDoc(doc(db, 'events', eventId));
    
    if (eventDoc.exists()) {
      return {
        id: eventDoc.id,
        ...eventDoc.data()
      };
    } else {
      throw new Error('Événement non trouvé');
    }
  } catch (error) {
    console.error('Erreur lors de la récupération de l\'événement:', error);
    throw error;
  }
};

// Récupérer tous les événements (pour une page générale)
export const fetchAllEvents = async (limitCount = 20) => {
  try {
    const eventsQuery = query(
      collection(db, 'events'),
      orderBy('date', 'desc'),
      limit(limitCount)
    );
    
    const querySnapshot = await getDocs(eventsQuery);
    const events = querySnapshot.docs.map(doc => ({
      id: doc.id,
      ...doc.data()
    }));
    
    return events;
  } catch (error) {
    console.error('Erreur lors de la récupération des événements:', error);
    throw error;
  }
};

// Récupérer les événements récents pour l'affichage sur la homepage
export const fetchRecentEvents = async (limitCount = 6) => {
  try {
    const eventsQuery = query(
      collection(db, 'events'),
      orderBy('date', 'desc'),
      limit(limitCount)
    );
    
    const querySnapshot = await getDocs(eventsQuery);
    const events = querySnapshot.docs.map(doc => ({
      id: doc.id,
      ...doc.data()
    }));
    
    return events;
  } catch (error) {
    console.error('Erreur lors de la récupération des événements récents:', error);
    throw error;
  }
};